import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5540fe9a")

_pushScopeId("data-v-5540fe9a")
const _hoisted_1 = { class: "flex flex-col w-full" }
const _hoisted_2 = {
  class: "flex w-full justify-between items-center px-2 pb-5",
  style: {"border-bottom":"1px solid #CFD8DC"}
}
const _hoisted_3 = { class: "font-semibold text-xl text-black" }
const _hoisted_4 = { class: "flex " }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", {
  class: "pi pi-calendar text-base cursor-pointer text-black mr-1",
  "aria:haspopup": "true"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "text-black font-semibold text-sm text-center" }, "Tanggal", -1)
const _hoisted_7 = { class: "p-input-icon-left w-full " }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_9 = { class: "mx-4 mt-2" }
const _hoisted_10 = { class: "excel-price-active px-3 h-5/6" }
const _hoisted_11 = { class: " grid grid-rows-1 grid-flow-col gap-4 " }
const _hoisted_12 = { class: "flex flex-col" }
const _hoisted_13 = { class: "flex flex-col overflow-y-auto " }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey text-center" }, " Tidak ada Data ", -1)
const _hoisted_16 = { class: "flex lg:items-center md:items-center items-start justify-between mb-1" }
const _hoisted_17 = { class: "font-bold lg:mr-0 md:mr-0 mr-2 break-all lg:w-auto md:w-auto w-auto flex-1 noresi" }
const _hoisted_18 = { class: "flex items-center justify-between mb-2" }
const _hoisted_19 = { class: "detail-route flex items-center" }
const _hoisted_20 = { class: " px-2 rounded-md lg:text-sm md:text-sm text-xs" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Berangkat : ")
const _hoisted_22 = { class: " color-green-darken-1 font-bold" }
const _hoisted_23 = { class: "flex flex-row items-center justify-between pt-2 " }
const _hoisted_24 = { class: "flex md:flex-row flex-col lg:items-center md:items-center items-start lg:w-2/3 md:w-2/3 w-full md:divide-x md:divide-green-500" }
const _hoisted_25 = { class: "flex sm:w-full md:w-auto md:mr-2" }
const _hoisted_26 = { class: "lg:px-1 my-1 lg:w-auto px-1" }
const _hoisted_27 = {
  class: "px-2 inline-block rounded-md font-semibold text-base color-green-darken-1",
  style: {"background-color":"#E8F5E9","color":"rgb(84, 110, 122)","border":"1px solid rgb(67, 160, 71)"}
}
const _hoisted_28 = {
  key: 0,
  class: "lg:px-1 my-1 lg:w-auto px-1"
}
const _hoisted_29 = {
  class: "px-2 inline-block rounded-md font-semibold text-base",
  style: {"background-color":"rgb(236, 239, 241)","color":"rgb(84, 110, 122)","border":"1px solid rgb(84, 110, 122)"}
}
const _hoisted_30 = { class: "flex md:flex-row lg:flex-row flex-row-reverse  md:justify-start justify-between sm:w-full md:w-auto md:divide-x md:divide-green-500" }
const _hoisted_31 = { class: "lg:w-auto px-2" }
const _hoisted_32 = /*#__PURE__*/_createVNode("span", { class: "color-blue-grey" }, "Total Resi : ", -1)
const _hoisted_33 = { class: "lg:w-auto px-2" }
const _hoisted_34 = /*#__PURE__*/_createVNode("span", { class: "color-blue-grey" }, "Total Barang : ", -1)
const _hoisted_35 = { class: "p-col-12 block" }
const _hoisted_36 = { class: "btn-action w-full flex justify-end mt-5" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Tanggal Sekarang")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Card = _resolveComponent("Card")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Button = _resolveComponent("Button")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isShowDialog,
    "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => (_ctx.isShowDialog = $event)),
    modal: true,
    dismissableMask: true,
    onHide: _cache[9] || (_cache[9] = ($event: any) => (_ctx.hideDialog())),
    breakpoints: {'960px': '75vw', '640px': '90vw'},
    style: {width: '50vw'}
  }, {
    header: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("h6", _hoisted_3, _toDisplayString(_ctx.title), 1),
          _createVNode("i", {
            class: "pi pi-times text-black cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideDialog()))
          })
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", {
            class: "filterChips",
            style: {borderRadius: '0px', marginRight: '0px'},
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDateFilterAct($event)))
          }, [
            _hoisted_5,
            _hoisted_6
          ]),
          _createVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: _ctx.inputSearch,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.inputSearch = $event)),
              placeholder: "Search",
              onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.getAllData(_ctx.inputSearch)), ["enter"])),
              class: "min-w-full",
              autofocus: ""
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createVNode("div", _hoisted_9, _toDisplayString(_ctx.moment(_ctx.dateFilter).format('dddd')) + ", " + _toDisplayString(_ctx.moment(_ctx.dateFilter).format('DD MMMM YYYY')) + ", " + _toDisplayString(_ctx.inputSearch?`"${_ctx.inputSearch}"`:""), 1)
      ])
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              (_ctx.data.length === 0)
                ? (_openBlock(), _createBlock("div", _hoisted_14, [
                    _hoisted_15
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (item) => {
                return (_openBlock(), _createBlock(_component_Card, {
                  key: item.Id,
                  style: {"min-height":"0"},
                  class: `cursor-pointer card-no-shadow mt-2 card-item-category ${(item.StatusPengirimanId === 6) ? 'background-grey-lighten-5': ''}`,
                  onClick: ($event: any) => (_ctx.showDetail(item.IdJadwal))
                }, {
                  content: _withId(() => [
                    _createVNode("div", _hoisted_16, [
                      _createVNode("h5", _hoisted_17, _toDisplayString(item.KodeJadwal), 1)
                    ]),
                    _createVNode("div", _hoisted_18, [
                      _createVNode("div", _hoisted_19, [
                        _createVNode("p", _hoisted_20, [
                          _hoisted_21,
                          _createVNode("span", _hoisted_22, _toDisplayString(_ctx.moment(item.TanggalAktif).format('DD MMMM YYYY, HH:mm')) + " WIB", 1)
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_23, [
                      _createVNode("div", _hoisted_24, [
                        _createVNode("div", _hoisted_25, [
                          _createVNode("div", _hoisted_26, [
                            _createVNode("p", _hoisted_27, _toDisplayString(item.Rit?`Rit ${item.Rit}`:''), 1)
                          ]),
                          false
                            ? (_openBlock(), _createBlock("div", _hoisted_28, [
                                _createVNode("p", _hoisted_29, _toDisplayString(item.Kode), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("div", _hoisted_30, [
                          _createVNode("div", _hoisted_31, [
                            _hoisted_32,
                            _createTextVNode(_toDisplayString(item.TotalBarang), 1)
                          ]),
                          _createVNode("div", _hoisted_33, [
                            _hoisted_34,
                            _createTextVNode(_toDisplayString(item.TotalResi), 1)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["class", "onClick"]))
              }), 128))
            ])
          ])
        ])
      ]),
      _createVNode(_component_OverlayPanel, {
        ref: "dateOpRef",
        id: "filter_overlay_panel",
        class: "p-5 over-dialog-mask"
      }, {
        default: _withId(() => [
          _createVNode("span", _hoisted_35, [
            _createVNode(_component_Calendar, {
              modelValue: _ctx.dateFilter,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dateFilter = $event)),
              inline: true,
              showWeek: true
            }, null, 8, ["modelValue"]),
            _createVNode("div", _hoisted_36, [
              (_ctx.dateFilter)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    label: "Filter",
                    class: "font-semibold p-button-sm btn-primary px-10 mx-2",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.saveFilterDateAct()))
                  }))
                : _createCommentVNode("", true),
              (_ctx.dateFilter)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    class: "btn-secondary text-black p-button-sm px-10 py-1",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clearFilterDateAct()))
                  }, {
                    default: _withId(() => [
                      _hoisted_37
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["visible"]))
})